<script setup lang="ts">
import { PhCaretDown } from '@phosphor-icons/vue'

import { NavigationMenuTrigger } from '../navigation-menu'
import { useMediaQuery } from '../utils/use-media-query'
import { AccordionTrigger } from '../accordion'

import { HeaderMenuLink } from '.'

defineProps<{
  url?: string,
  ariaLabel?: string
}>()

const isDesktop = useMediaQuery('md')
</script>

<template>
  <div v-if="isDesktop"
       class="flex items-center">
    <NavigationMenuTrigger as-child>
      <HeaderMenuLink :href="url"
                      class="data-[state=open]:text-header-highlight">
        <slot />
      </HeaderMenuLink>
    </NavigationMenuTrigger>
    <NavigationMenuTrigger class="mr-4 -ml-3 data-[state=open]:text-header-highlight [&>svg]:data-[state=open]:rotate-180 focus-visible:outline-offset-2"
                           :aria-label="ariaLabel">
      <PhCaretDown weight="bold"
                   class="w-6 h-6 transition duration-200" />
    </NavigationMenuTrigger>
  </div>
  <AccordionTrigger v-else
                    :is-header="true"
                    as="div"
                    class="data-[state=open]:bg-primary-200 [&>:last-child]:pr-4 !py-0">
    <HeaderMenuLink :href="url || '#'">
      <slot />
    </HeaderMenuLink>
  </AccordionTrigger>
</template>
